import { useQueryState } from 'nuqs'
import { searchParamsParsers } from '#app/utils/search-params'
import { disableTransitions } from '#app/utils/transition-utils'
import { Toggle } from './shared/toggle/toggle'

export function CustomizeDarkMode() {
	const [darkMode, setDarkMode] = useQueryState(
		'darkMode',
		searchParamsParsers.darkMode,
	)

	return (
		<div className="flex items-center justify-between gap-2">
			<h2 className="text-primary text-sm font-semibold">Dark Mode</h2>

			<Toggle
				className="keep-transitions"
				aria-label="Dark Mode"
				isSelected={darkMode === 'true'}
				onChange={(isSelected) => {
					// Disable transitions except for elements with 'keep-transitions' class
					disableTransitions()

					// Apply the dark mode change
					void setDarkMode(isSelected ? 'true' : 'false')
				}}
			/>
		</div>
	)
}
